import { otherLanguages } from '../constants/Language';
import {
  getAccountsData,
  getAccountStatusData,
  addAccountData,
  addShopAccountData,
  addGroupAccountData,
  addGroupAccountAdminData,
  editAccountEmailData,
  editAccountStatusData,
  getAccountByEmailData,
  addAccountGroupData,
  validateAccountEmailData
} from '../libs/apis/AccountApi';

export const GET_ACCOUNT_REQUEST = 'GET_ACCOUNT_REQUEST';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_FAILURE = 'GET_ACCOUNT_FAILURE';

export const GET_ACCOUNT_STATUS_REQUEST = 'GET_ACCOUNT_STATUS_REQUEST';
export const GET_ACCOUNT_STATUS_SUCCESS = 'GET_ACCOUNT_STATUS_SUCCESS';
export const GET_ACCOUNT_STATUS_FAILURE = 'GET_ACCOUNT_STATUS_FAILURE';

export const ADD_ACCOUNT_REQUEST = 'ADD_ACCOUNT_REQUEST';
export const ADD_ACCOUNT_SUCCESS = 'ADD_ACCOUNT_SUCCESS';
export const ADD_ACCOUNT_FAILURE = 'ADD_ACCOUNT_FAILURE';

export const ADD_ACCOUNT_GROUP_REQUEST = 'ADD_ACCOUNT_GROUP_REQUEST';
export const ADD_ACCOUNT_GROUP_SUCCESS = 'ADD_ACCOUNT_GROUP_SUCCESS';
export const ADD_ACCOUNT_GROUP_FAILURE = 'ADD_ACCOUNT_GROUP_FAILURE';

export const ADD_SHOP_ACCOUNT_REQUEST = 'ADD_SHOP_ACCOUNT_REQUEST';
export const ADD_SHOP_ACCOUNT_SUCCESS = 'ADD_SHOP_ACCOUNT_SUCCESS';
export const ADD_SHOP_ACCOUNT_FAILURE = 'ADD_SHOP_ACCOUNT_FAILURE';

export const ADD_GROUP_ACCOUNT_REQUEST = 'ADD_GROUP_ACCOUNT_REQUEST';
export const ADD_GROUP_ACCOUNT_SUCCESS = 'ADD_GROUP_ACCOUNT_SUCCESS';
export const ADD_GROUP_ACCOUNT_FAILURE = 'ADD_GROUP_ACCOUNT_FAILURE';

export const EDIT_ACCOUNT_EMAIL_REQUEST = 'EDIT_ACCOUNT_EMAIL_REQUEST';
export const EDIT_ACCOUNT_EMAIL_SUCCESS = 'EDIT_ACCOUNT_EMAIL_SUCCESS';
export const EDIT_ACCOUNT_EMAIL_FAILURE = 'EDIT_ACCOUNT_EMAIL_FAILURE';

export const EDIT_ACCOUNT_STATUS_REQUEST = 'EDIT_ACCOUNT_STATUS_REQUEST';
export const EDIT_ACCOUNT_STATUS_SUCCESS = 'EDIT_ACCOUNT_STATUS_SUCCESS';
export const EDIT_ACCOUNT_STATUS_FAILURE = 'EDIT_ACCOUNT_STATUS_FAILURE';

export const COUNT_ACCOUNT_EMAIL_REQUEST = 'COUNT_ACCOUNT_EMAIL_REQUEST';
export const COUNT_ACCOUNT_EMAIL_SUCCESS = 'COUNT_ACCOUNT_EMAIL_SUCCESS';
export const COUNT_ACCOUNT_EMAIL_FAILURE = 'COUNT_ACCOUNT_EMAIL_FAILURE';

export const VALIDATE_ACCOUNT_EMAIL_REQUEST = 'VALIDATE_ACCOUNT_EMAIL_REQUEST';
export const VALIDATE_ACCOUNT_EMAIL_SUCCESS = 'VALIDATE_ACCOUNT_EMAIL_SUCCESS';
export const VALIDATE_ACCOUNT_EMAIL_FAILURE = 'VALIDATE_ACCOUNT_EMAIL_FAILURE';

export const RE_IDENTITY_ACTION = 'RE_IDENTITY_ACTION';

export const getAccounts = (params, headers = {}) => dispatch => {
  dispatch({ type: GET_ACCOUNT_REQUEST });
  const cognitoUserId = localStorage.getItem('cognitoUserId');
  if (cognitoUserId) {
    // eslint-disable-next-line no-param-reassign
    params.cognitoUserId = cognitoUserId;
  }
  return getAccountsData(params, headers)
    .then(response =>
      dispatch({
        type: GET_ACCOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_ACCOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getAccountStatus = shopId => dispatch => {
  dispatch({ type: GET_ACCOUNT_STATUS_REQUEST });
  return getAccountStatusData(shopId)
    .then(response =>
      dispatch({
        type: GET_ACCOUNT_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_ACCOUNT_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addAccount = params => dispatch => {
  dispatch({ type: ADD_ACCOUNT_REQUEST });
  return addAccountData(params)
    .then(response =>
      dispatch({
        type: ADD_ACCOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_ACCOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addAccountGroup = params => dispatch => {
  dispatch({ type: ADD_ACCOUNT_GROUP_REQUEST });
  return addAccountGroupData(params)
    .then(response =>
      dispatch({
        type: ADD_ACCOUNT_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_ACCOUNT_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addShopAccount = params => dispatch => {
  let addParams = { ...params };
  if (!params.otherLanguage) {
    addParams = {
      ...addParams,
      otherLanguages
    };
  }
  dispatch({ type: ADD_SHOP_ACCOUNT_REQUEST });
  return addShopAccountData(addParams)
    .then(response =>
      dispatch({
        type: ADD_SHOP_ACCOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_SHOP_ACCOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGroupAccount = params => dispatch => {
  dispatch({ type: ADD_GROUP_ACCOUNT_REQUEST });
  return addGroupAccountData(params)
    .then(response =>
      dispatch({
        type: ADD_GROUP_ACCOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GROUP_ACCOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGroupAccountAdmin = params => dispatch => {
  dispatch({ type: ADD_GROUP_ACCOUNT_REQUEST });
  return addGroupAccountAdminData(params)
    .then(response =>
      dispatch({
        type: ADD_GROUP_ACCOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GROUP_ACCOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editAccountEmail = (manageAccountId, params) => dispatch => {
  dispatch({ type: EDIT_ACCOUNT_EMAIL_REQUEST });
  return editAccountEmailData(manageAccountId, params)
    .then(response =>
      dispatch({
        type: EDIT_ACCOUNT_EMAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_ACCOUNT_EMAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editAccountStatus = (manageAccountId, params) => dispatch => {
  dispatch({ type: EDIT_ACCOUNT_STATUS_REQUEST });
  return editAccountStatusData(manageAccountId, params)
    .then(response =>
      dispatch({
        type: EDIT_ACCOUNT_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_ACCOUNT_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const countAccountEmail = email => dispatch => {
  dispatch({ type: COUNT_ACCOUNT_EMAIL_REQUEST });
  return getAccountByEmailData({ email })
    .then(response =>
      dispatch({
        type: COUNT_ACCOUNT_EMAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: COUNT_ACCOUNT_EMAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const validateAccountEmail = email => dispatch => {
  dispatch({ type: VALIDATE_ACCOUNT_EMAIL_REQUEST });
  return validateAccountEmailData({ email })
    .then(response =>
      dispatch({
        type: VALIDATE_ACCOUNT_EMAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: VALIDATE_ACCOUNT_EMAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const reIdentity = status => dispatch => {
  return dispatch({ type: RE_IDENTITY_ACTION, payload: { status } });
};
